/**
 * Redux selectors for auth state
 */

// Basic selectors
export const selectAuth = (state) => state.auth;
export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectAuthError = (state) => state.auth.error;
export const selectToken = (state) => state.auth.token;
export const selectAuthInitializing = (state) => state.auth.initializing;

// Computed selectors
export const selectUserData = (state) => state.auth.user?.userData;
export const selectCustomerId = (state) => state.auth.user?.customer_id;
export const selectFullName = (state) => state.auth.user?.full_name;
export const selectUserRole = (state) => state.auth.user?.role || 'user';

// Validation selectors
export const selectHasValidSession = (state) => {
  const auth = state.auth;
  return auth.isAuthenticated && auth.user && (auth.token || localStorage.getItem('token'));
};

export const selectIsAdmin = (state) => {
  const user = state.auth.user;
  return user?.role === 'admin' || user?.role === 'super_admin';
};

export const selectIsUser = (state) => {
  const user = state.auth.user;
  return user?.role === 'user';
};